import _ from 'lodash'
import React, { Component } from 'react';
import { connect } from 'react-redux'
import PageBuilderForm from './form/PageBuilderForm'
import InsideAddonForm from './form/InsideAddonForm'
import { saveInsideAddon, loadInitialValue } from './form/actions/index.js'
import deepEqual from 'deep-equal'

class PageBuilderFormWrap extends Component {

  constructor(props) {
    super(props);
    this.insideHandleForm= this.insideHandleForm.bind(this);
  }

  insideHandleForm(values){
     var fieldData = this.props.state.sppbForm.activeField
    this.props.saveInsideAddon(values,fieldData)
  }

  componentWillReceiveProps(nextProps){
    if(!deepEqual(this.props.settings, nextProps.settings) || !deepEqual(this.props.addon, nextProps.addon)){
      this.initValuesOnUpdate(nextProps);
    }
  }


  componentDidMount() {
    this.initValuesOnUpdate(this.props);
  }

  initValuesOnUpdate(props){
    const { addonName, toggleType, settings } = props
    var addonOps, newSettings;

    if (_.isEmpty( settings )) {
        if ( toggleType == 'addon' || toggleType == 'inner_addon' ) {

            addonOps = addonsJSON[addonName];
            newSettings = addonOps.default

          /* addGlobalSettings */
        } else if ( toggleType == 'column' || toggleType == 'inner_column' ) {
            newSettings = colSettings.default
        } else if ( toggleType == 'row' || toggleType == 'inner_row' ) {
            newSettings = rowSettings.default;
        }
    } else {
        newSettings = settings;
    }

    this.props.loadInitialValue( toggleType, newSettings, addonName )
  }

  render(){

    const { addonName, toggleType, settings } = this.props

    let onchangeCB = null;
    let onchangeCbInside = null;
    let showButtons = true;

    if(toggleType == 'addon' || toggleType == 'inner_addon'){
      let addonOps = addonsJSON[addonName];

      if(addonOps.js_template){
        onchangeCB = this.props.onSubmit;
        showButtons = false;
      }
      if(addonsJSON[this.props.state.sppbForm.activeField.addonName] !== undefined && addonsJSON[this.props.state.sppbForm.activeField.addonName].js_template && this.props.state.sppbForm.form == 'insideForm'){
        onchangeCbInside = this.insideHandleForm;
        showButtons = false;
      }
    }  else if(toggleType == 'row' || toggleType == 'inner_row' || toggleType == 'column' || toggleType == 'inner_column'){
      onchangeCB = this.props.onSubmit;
      showButtons = false;
    }

    if(this.props.state.sppbForm.form == 'insideForm' && !addonsJSON[this.props.state.sppbForm.activeField.addonName].js_template){
      showButtons = true;
    }

    if(showButtons || this.props.state.sppbForm.form == 'insideForm'){
      document.body.classList.add('sppb-have-ajax-addon');
    } else {
      document.body.classList.remove('sppb-have-ajax-addon');
    }

    

    return(
      <div>
        {
          this.props.state.sppbForm.form !='' &&
          <PageBuilderForm onSubmit = { this.props.onSubmit } onChange={ onchangeCB } showButtons={showButtons} onCloseModal = { this.props.onCloseModal } />
        }
        {
          this.props.state.sppbForm.form == 'insideForm' &&
          <InsideAddonForm onSubmit = { this.insideHandleForm } onChange={ onchangeCbInside } showButtons={showButtons} onCloseModal = { this.props.onCloseModal } />
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    state
  };
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    saveInsideAddon: (values,fieldData) => {
      dispatch( saveInsideAddon(values,fieldData) )
    },
    loadInitialValue: ( addonType, settings, nameOfAddon ) => {
      dispatch( loadInitialValue( addonType, settings, nameOfAddon ) )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PageBuilderFormWrap);



// WEBPACK FOOTER //
// ./src/helpers/PageBuilderFormWrap.js